import { library } from '@fortawesome/fontawesome-svg-core'
//import { fab } from '@fortawesome/free-brands-svg-icons'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import {faCaretDown ,faSearch, faChevronRight, faChevronLeft, faPlaneDeparture, faPlaneArrival, faSearchMinus, faSearchPlus, faPlusCircle, faTrashAlt, faShareAlt, faSun, faCloud, faCloudSun, faCloudSunRain, faCloudShowersHeavy, faSpinner, faEnvelope, faLock, faBan, faStar, faPenSquare, faCircleNotch, faUserAlt, faUserAltSlash} from '@fortawesome/free-solid-svg-icons'
import React, { useEffect, useState, Suspense, lazy } from 'react';
import AdminLayout from "./admin/layouts/Admin/Admin.js";
import { socket, socketContext } from './utils/socket'
import { setLogin } from './redux/actions'
import { getUserToken } from './redux/reducers'
import { connect } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.css';
import Cookies from 'universal-cookie'
import api from './utils/axiosApi'
import UserLeaveConfirmation from './utils/UserLeaveConfirmation'
import logo from './img/logoW.avif'

import './components/PopUpStyles.css'
import './components/LoadingCurtain/styles.css'
import './pages/generalStyles.css'
import './i18n/config';
import './App.css'
/*import CalendarPage from './pages/CalendarPageClss'
import UsersCalendarsPage from './pages/UsersCalendars'
import LandingPage from './pages/LandingPage'
import SearchPage from './pages/SearchPage'
import LoginPage from './pages/LoginPage'
import CalendarViewerPage from './pages/CalendarViewerPage'
import AddUsersCalendarPage from './pages/AddUsersCalendarPage'
import LoginPage from './pages/LoginPage'
import SearchPage from './pages/SearchPage'
*/
import ChangePageMetrics from './utils/ChangePageMetrics.js';
const LoginPage = lazy(() => import('./pages/LoginPage'));

const cookies = new Cookies()

library.add(faUserAlt, faUserAltSlash ,faCircleNotch,faPenSquare,faStar,faBan,faLock,faEnvelope, faSpinner,faSearch, faCaretDown, faChevronRight, faChevronLeft, faPlaneDeparture, faPlaneArrival, faSearchMinus, faSearchPlus, faPlusCircle, faTrashAlt, faShareAlt, faSun, faCloud, faCloudSun, faCloudSunRain, faCloudShowersHeavy  )
/*const renderCalendar = () => <CalendarPage/>
const renderCustomerToCalendar = () => <AddUsersCalendarPage/>
const renderViewer = () => <CalendarViewerPage/>
const renderCalendars = () => <UsersCalendarsPage/>
const renderSearch = () => <SearchPage/>
const renderLogin = () => <LoginPage/>
const renderLandingPage = () => <LandingPage/>
const renderInfoPage = () => <SearchPage/>*/

function App({token, setLogin}) {
  const [track, setTrack] = useState(false)
  useEffect(() => {
    const trackcookie = cookies.get('trackingAcept')
    if(trackcookie) {
      setTrack(false)
    } else {
      setTrack(true)
    }
  }, [track])
  useEffect(() => {
    const tokencookie = window.sessionStorage.getItem('jwtuser')|| localStorage.getItem('jwtuser') //cookies.get('jwtuser')
    if(tokencookie) {
      setLogin(tokencookie)
      api.defaults.headers.common['Authorization'] = `Bearer ${tokencookie}`
    }
  }, [setLogin])
  
  const [confirmOpen, setConfirmOpen] = useState(true);
  return (
    <>

      <Router
      getUserConfirmation={(message, callback) => {
          return UserLeaveConfirmation(
            message,
            callback,
            confirmOpen,
            setConfirmOpen
          );
        }}
      >
      <ChangePageMetrics>

        <Suspense fallback={<>
          <div style={{
              color: '#E5E9F2' ,
              fontSize: '100px',
              width:'100vw', 
              height: 'calc(100vh - 70px)', 
              display: 'flex', 
              justifyContent: 'center', alignItems: 'center'}}>
          <div className='loader-Cont'>
              <div className='loader loader1'></div>
              <div className='loader loader2'></div>
              <div className='loader-Logo'>

              <img className='d-block' alt='logo' src={logo}></img>
              </div>
          </div>
          </div>
        </>} >
              <Switch>
                <Route path="/login" component={LoginPage} />
                <Route path="*" component={AdminLayout}/>
              </Switch>
        </Suspense>
      </ChangePageMetrics>
            {/*
            <div style={{position:'fixed', bottom: 0, left:'5px', zIndex:50}}>
                <ChangeLngBtn></ChangeLngBtn>
            </div>*/}
      </Router>
      
    </>
  );
}

const mapStateToProps = state => {
  return ({
      token:getUserToken(state)
})}
const mapDispatchToProps = dispatch => (
  {
      setLogin: value =>dispatch(setLogin(value)),
  })
/*
{track && <div className='d-flex justify-content-end align-items-end' style={{
        zIndex:1000000000,
        position: 'fixed', 
        top:'0',
        bottom: '0',
        left: '0',
        right: '0',
        backgroundColor: 'rgba(0,0,0,0.7)'
        
        }}>
          <div className='TrackingCookies'
          >
          <p>Esta pagina hace uso de cookies de recoleccion de datos para poder mejorar la experiancia de usuario, es necesario aceptar para poder continuar</p>
          <button onClick={() => {
            cookies.set('trackingAcept', true)
            setTrack(false)
          }} type='button'>Aceptar</button>
          </div>
        </div>}
*/
export default connect(mapStateToProps,mapDispatchToProps)(App);

/* <Switch>
              <Route path="/login" render={renderLogin} />
              <Route path="/signup" render={renderLogin} />

              <Route path="/Activities/:idCities"  render={renderSearch} />
              <Route path="/search"  render={renderSearch} />
              <Route path="/calendars"  render={renderCalendars} />
              <Route path="/viewcalendar/:id"  render={renderViewer} />
              <Route path="/calendar/:id"  render={renderCalendar} />
              <Route path="/info/:placeId"  render={renderInfoPage} />

              <Route path="/CustomerTocalendar/:id"  render={renderCustomerToCalendar} />
              <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
              <Route path="*" render={renderLandingPage} />
            </Switch> */
